import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { useHover } from 'react-native-web-hooks';
import { Colors, Text } from 'advance-components';
const WIDTH = 210;
const ItemContainer = styled.Pressable`
  padding-horizontal: 16px;
  padding-vertical: 12px;
  width: ${WIDTH}px;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${_ref => {
  let {
    hovered
  } = _ref;
  return hovered ? Colors.lightGray200 : Colors.white;
}};
`;
export default function HelpMenuItem(_ref2) {
  let {
    label,
    onPress
  } = _ref2;
  const ref = useRef();
  const hovered = useHover(ref);
  return /*#__PURE__*/React.createElement(ItemContainer, {
    ref: ref,
    hovered: hovered,
    onPress: onPress
  }, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, null, label));
}
HelpMenuItem.defaultProps = {
  label: '',
  onPress: () => {}
};
HelpMenuItem.propTypes = {
  label: PropTypes.string,
  onPress: PropTypes.func
};
//# sourceMappingURL=help-menu-item.js.map